module.exports = __webpack_public_path__ + "img/REDACAO.57bbe6fd.png";